"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamService = void 0;
const OpenAPI_1 = require("../core/OpenAPI");
const request_1 = require("../core/request");
class TeamService {
    /**
     * @param id
     * @returns TeamType The teams data for given ids for the logged in user
     * @throws ApiError
     */
    static getTeams(id) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/teams',
            query: {
                'id': id,
            },
            errors: {
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns NewTeam The new team
     * @throws ApiError
     */
    static createTeam(requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v1/team',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Unauthorized`,
            },
        });
    }
    /**
     * @param teamId
     * @param requestBody
     * @returns SubscriptionCheckoutResponse Success
     * @throws ApiError
     */
    static createCheckoutSession(teamId, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v1/team/{teamId}/subscriptions/checkout',
            path: {
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param teamId
     * @param requestBody
     * @returns ProcessSubscriptionResponse Success
     * @throws ApiError
     */
    static processSubscription(teamId, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v1/team/{teamId}/subscriptions/process',
            path: {
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param teamId
     * @returns RefreshSubscriptionResponse Success
     * @throws ApiError
     */
    static refreshTeamSubscription(teamId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v1/team/{teamId}/subscriptions/refresh',
            path: {
                'teamId': teamId,
            },
        });
    }
    /**
     * @param teamId
     * @param coupon
     * @returns GetPlansResponse Success
     * @throws ApiError
     */
    static getPlans(teamId, coupon) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v1/team/{teamId}/plans',
            path: {
                'teamId': teamId,
            },
            query: {
                'coupon': coupon,
            },
        });
    }
    /**
     * @param teamId
     * @returns any Success
     * @throws ApiError
     */
    static getTeamSubscription(teamId) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'GET',
            url: '/v1/team/{teamId}/subscriptions',
            path: {
                'teamId': teamId,
            },
        });
    }
    /**
     * @param teamId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    static updateTeamSubscriptionPaymentMethod(teamId, requestBody) {
        return (0, request_1.request)(OpenAPI_1.OpenAPI, {
            method: 'POST',
            url: '/v1/team/{teamId}/subscriptions/payment_method/update',
            path: {
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.TeamService = TeamService;
